export default "__VITE_ASSET__BHrj7rPX__"